import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const deleteLeader = ({
  churchId,
  leaderId,
  isDenominationChurch = false
}) => {
  if (isDenominationChurch) {
    return axios.delete(
      `/denomination-churches/${churchId}/leaders/${leaderId}`
    );
  }
  return axios.delete(`/churches/${churchId}/leaders/${leaderId}`);
};

export const useDeleteLeader = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDeleteModal = useCentralStore.getState().closeDeleteModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["leaders"]);
      setNotification({
        type: "success",
        message: "Leader deleted successfully!"
      });
      closeDeleteModal();
    },
    ...config,
    mutationFn: deleteLeader
  });
};
